import { render, staticRenderFns } from "./ComitenteSubmenu.vue?vue&type=template&id=0c91ec38&"
import script from "./ComitenteSubmenu.vue?vue&type=script&lang=js&"
export * from "./ComitenteSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports